module.exports = __webpack_public_path__ + "img/20210116_110027.177be468.jpg";